import { LitElement, html, css, TemplateResult, CSSResult } from 'lit';
import {property, customElement} from 'lit/decorators.js';

export interface ModalPos {
    x: number,
    y: number
}

@customElement("voy-modal")
export class VoyModal extends LitElement
{
    @property({ attribute: false }) content: TemplateResult | HTMLElement | null = null;
    @property({ attribute: false }) modalPos?: ModalPos|null = null;
    
    constructor()
    {
        super();

        this.addEventListener("click", () => {
            this.close();
        });
    }

    static get styles() {
        return [
            css`
            /* backdrop for closing on click outside of modal */
            :host {
                position: fixed;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                z-index: 1000;
                background: rgba(0, 0, 0, 0.2); 
            }

            :host([shown]) {
                display: flex;
            }

            svg {
                display: block;
            }

            #closeButton {
                position: absolute;
                top: 21px;
                right: 10px;
                padding: 0;
                background: none;
                border: none;
                outline: none;
                cursor: pointer;
                fill: var(--neutrals-grey-04, grey);
            }

            /* modalContainer holds the provided element */
            #modal-container {
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
                width: fit-content;
                height: fit-content;
                max-height: 100%;
                max-width: 100%;
                border-radius: 3px;
                border: 1px solid var(--neutrals-grey-06, black);
                box-shadow: 5px 5px 10px rgba(0,0,0,0.5);
                background: var(--neutrals-grey-10, white);

                position: fixed;
                z-index: 1000;
                z-index: 1000;
                width: fit-content;
                height: fit-content;
            }

            #content {
                width: fit-content;
                height: fit-content;
                flex-shrink: 1;
            }
        `];
    }

    render() {
        return html`
            <div id="modal-container" @click=${ (event: MouseEvent) => event.stopPropagation() }>
                <div id="content">
                    ${this.content}
                </div>
            </div>
        `;
    }

    firstUpdated(): void {
        const el =  (<HTMLElement>this.shadowRoot!.querySelector("#modal-container"));
        if (this.modalPos) {
            el.style.cssText = `
                top: ${this.modalPos.y}px;
                left: ${this.modalPos.x}px;
            `;
        }
        else
        {
            // if position is not provided, then default to center of screen
            this.style.cssText = `
                display: flex;
                justify-content: center;
                align-items: center;
            `
        }
    }

    close()
    {
        this.remove();
    }
}
